import React, { useState }  from "react";
import { useTranslation } from "react-i18next";

import Spinner from "../../App/Components/Spinner/Spinner";
import DataStoreDataProvider from "../../App/Components/Table/DataProvider/DataStoreDataProvider";
import {default as TableComponent} from "../../App/Components/Table/Table";
import TableColumn from "../../App/Components/Table/TableColumn";

import DepositDataStore from "../DataStore/DepositDataStore";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faEye, faExclamation, faEnvelope, faQuestion, faCheck, faCog, faClock, faEuroSign} from '@fortawesome/free-solid-svg-icons';
import {library} from '@fortawesome/fontawesome-svg-core';

export default function Overview()
{
    const {t, i18n} = useTranslation();
    const [dataProvider, setDataProvider] = useState(null);

    if (null === dataProvider) {
        setDataProvider(new DataStoreDataProvider(DepositDataStore, 'getDeposits'));

        return <Spinner/>;
    }

    library.add(faExclamation, faEnvelope, faQuestion, faCheck, faCog, faClock, faEuroSign)

    return <div>
        <h2>{t('Deposits')}</h2>
        <TableComponent dataProvider={dataProvider} pageSize={25} sorting={{created_at: 'DESC'}}>
            <TableColumn dataKey={"customer"}
                         editable={false}
                         collapsable={true}
                         sortable={false}
                         transform={(value) => {
                             return value.first_name + ' ' + value.last_name;
                         }}
                         url={(value) => {
                             return '/customers/' + value.id;
                         }}
            >
                {t('Customer')}
            </TableColumn>
            <TableColumn dataKey={"created_at"}
                         editable={false}
                         collapsable={true}
                         sortable={true}
                         transform={(value) => {
                             return moment(value).format('D MMM YYYY HH:mm')
                         }}
            >
                {t('Created at')}
            </TableColumn>
            <TableColumn dataKey={"appointment_at"}
                         editable={false}
                         collapsable={true}
                         sortable={false}
                         transform={(value) => {
                             if ('potentially more than one appointment' == value) {
                                 return null;
                             }
                             return moment(value).format('D MMM YYYY HH:mm');
                         }}
                         url={(value) => {
                             if ('potentially more than one appointment' == value) {
                                 return null;
                             }
                             return '/calendar/' + moment(value).format('YYYY-MM-DD');
                         }}
            >
                {t('Appointment at')}
            </TableColumn>
            <TableColumn dataKey={"fulfilled_at"}
                         editable={false}
                         collapsable={true}
                         sortable={false}
                         transform={(value) => {
                             if (typeof value === 'undefined' || null === value) {
                                 return null;
                             }

                             return moment(value).format('D MMM YYYY HH:mm')
                         }}
                         url={(value, row) => {
                             if (typeof value === 'undefined' || null === value) {
                                 return false;
                             }

                             return '/register/receipt/' + row.fulfilled_receipt_id;
                         }}
            >
                {t('Fulfilled at')}
            </TableColumn>
            <TableColumn dataKey={"amount"}
                         editable={false}
                         collapsable={false}
                         transform={(value) => {
                             if (isNaN(value)) return value;
                             return value.toFixed(2).toString().replace('.', ',');
                         }}
            >
                {t('Amount')}
            </TableColumn>
            <TableColumn dataKey={"status"}
                         editable={false}
                         collapsable={false}
                         iconMap={{
                             canceled: {icon: "exclamation", class: "warning", tooltip: "Canceled"},
                             sent: {icon: "envelope", class: "info", tooltip: "Sent"},
                             requested: {icon: "question", class: "info", tooltip: "Requested"},
                             expired: {icon: "exclamation", class: "warning", tooltip: "Expired"},
                             failed: {icon: "exclamation", class: "error", tooltip: "Failed"},
                             paid: {icon: "check", class: "success", tooltip: "Paid"},
                             processing: {icon: "cog", class: "info", tooltip: "Processing"},
                             queued: {icon: "clock", class: "info", tooltip: "Queued"},
                             pending: {icon: "clock", class: "info", tooltip: "Pending"},
                             refunded: {icon: "check", class: "error", tooltip: "Refunded"},
                             registerPaid: {icon: "euro-sign", class: "success", tooltip: "Register paid"},
                             registerUnpaid: {icon: "euro-sign", class: "error", tooltip: "Register unpaid"},
                             collected: {icon: "check", class: "info", tooltip: "Collected"},
                         }}
            >
                {t('Status')}
            </TableColumn>
            <TableColumn dataKey={"appointment-deposit-id"}
                         editable={false}
                         collapsable={false}
                         sortable={false}
                         transform={(value) => {
                             if (null !== value) {
                                 return <FontAwesomeIcon icon={faEye}/>
                             }
                         }}
                         url={(value) => {
                             if (null !== value) {
                                 return '/register/appointment-deposits/' + value;
                             }
                         }}
            >
                {t('View')}
            </TableColumn>
        </TableComponent>
    </div>;
}
